import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import connect from 'react-redux/lib/connect/connect';
import { reduxForm, SubmissionError } from 'redux-form';
import { CONSOLIDATED_CASH_CLOSE_FORM, mapUiObjectToPayload } from './ConsolidatedCashCloseDialogUtil';
import DialogComponent from '../DialogComponent/DialogComponent';
import { dispatchCreateConsolidatedCashCloseRequest } from '../../redux/modules/consolidatedCashClose/consolidatedCashClose-actions';
import { displayWarning } from '../../redux/modules/warningDialog/warningDialog-actions';
import ConsolidatedCashCloseDialogForm from './ConsolidatedCashCloseDialogForm';
import { getStringFromObject } from '../../constants/lodashUtils';

const styles = () => ({
    paper: {
        overflow: 'visible',
        background: '#fafafa',
    },
    dialog: {
        minHeight: '750px',
    },
    title: {
        fontSize: '1.3rem',
        fontWeight: '400',
        padding: '12px 24px',
    },
});

class ConsolidatedCashCloseDialog extends React.PureComponent {
    handleSubmitForm = (formValues) => {
        const payload = mapUiObjectToPayload(formValues);
        if (payload.error) {
            throw new SubmissionError({ userEnteredConsolidatedCashCollections: { _error: payload.error } });
        }
        const { dispatch } = this.props;
        dispatch(dispatchCreateConsolidatedCashCloseRequest(payload));
    };

    handleClose = () => {
        const {
            pristine,
            dispatch,
            handleClose,
        } = this.props;
        if (!pristine) {
            dispatch(displayWarning(
                'You have made some changes, are you sure want to cancel ?',
                handleClose,
                false,
            ));
        } else {
            handleClose();
        }
    };

    render() {
        const {
            formValues,
            classes,
            handleSubmit,
        } = this.props;
        const editable = !formValues.uuid;
        console.log('kjhlasdjfhjkasdfh', this.props, editable);
        return (
            <DialogComponent
                open
                maxWidth="lg"
                className={classes.dialog}
                classes={{
                    paper: classes.paper,
                }}
                header="Daily Consolidated Cash Close"
                handleClose={this.handleClose}
            >
                <ConsolidatedCashCloseDialogForm
                    {...this.props}
                    submitForm={handleSubmit(this.handleSubmitForm)}
                    handleClose={this.handleClose}
                />
            </DialogComponent>
        );
    }
}

ConsolidatedCashCloseDialog.propTypes = {
    handleClose: PropTypes.func,
    classes: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    formValues: PropTypes.object,
    selected: PropTypes.object,
    consolidatedCashCloseId: PropTypes.number,
    pristine: PropTypes.bool.isRequired,
};

ConsolidatedCashCloseDialog.defaultProps = {
    handleClose: () => {},
    classes: {},
    formValues: {},
    selected: null,
    consolidatedCashCloseId: null,
};

const mapStateToProps = state => ({
    selected: getStringFromObject('consolidatedCashClose.selected', state, null),
    formValues: getStringFromObject(`form.${CONSOLIDATED_CASH_CLOSE_FORM}.values`, state, {}),
});

export default connect(mapStateToProps)(reduxForm({
    form: CONSOLIDATED_CASH_CLOSE_FORM,
})(withStyles(styles)(ConsolidatedCashCloseDialog)));

